
var angular: angular.IAngularStatic = require('angular');
import {Injectable, Inject} from 'ng-metadata/core';
import { PrimolyticsService } from '../../../../analytics/primolytics.service';
import { PrimoExploreService } from '../../../../primoExplore/primoExplore.service';
import { ConfigurationUtil } from '../../../../nddUtils/configurationUtil.service';
import { MappingTablesCache } from '../../../../mappingTablesCache/mappingTablesCache.service';
import { PermalinkService } from '../../../actions/permalinkAction/permalink.service';
import { HttpService } from '../../../../infra/httpRequest/http.service';

@Injectable()
export class PickupAnywhereService {
    private _selectedPickupInformation: Object;

    private ngrsPickupInformationUrl:any;

    constructor(private primolyticsService: PrimolyticsService,
                private primoExploreService: PrimoExploreService,
                private configurationUtil : ConfigurationUtil,
                private mappingTablesCache: MappingTablesCache, 
                private permalinkService: PermalinkService,
                private httpService: HttpService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('restBaseURLs') private restBaseURLs) {

        this.ngrsPickupInformationUrl = restBaseURLs.ngrsPickupInformationUrl;
    }

    public getPickupInformation() {
        return this.httpService.call('GET', this.ngrsPickupInformationUrl, {})
            .then(
                (response)=> {
                    return response;
                },
                (error)=>{
                    console.log('=================> Failed to find pickup information');
                }
            );
    }

    public setSelectedPickupInformation(_selectedPickupInformation: Object) {
        this._selectedPickupInformation = _selectedPickupInformation;
    }

    public getSelectedPickupInformation() {
        return this._selectedPickupInformation;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/pickup-anywhere-form/pickupAnywhereForm.service.ts